import sharedNotificationsReducer from 'library/src/notifications/redux/NotificationsReducer';
import sharedReportReducers from 'library/src/report/redux/SharedReportReducer';
import reportReducer from 'modules/report/redux/ReportReducers';
import SubscriptionsReducers from 'modules/subscriptions/reducers/SubscriptionsReducers';
import visioCropReducers from 'modules/visio_crop/reducers/VisioCropReducers';
import WeatherReducers from 'modules/weather/reducers/WeatherReducers';
import {sharedProcessingReducer} from '../../library/src/processing/redux/SharedProcessingReducer';
import AuthReducers from '../../modules/auth/reducers/AuthReducers';
import CampaignsReducers from '../../modules/campaigns/reducers/CampaignsReducers';
import {sharedCommercialPackagesReducer} from '../../modules/commercialPackages/redux/SharedCommercialPackagesReducer';
import {sharedContractReducer} from '../../modules/contracts/redux/SharedContractReducer';
import CropsReducers from '../../modules/crops/reducers/CropsReducers';
import FieldsReducers from '../../modules/fields/reducers/FieldsReducers';
import NitrogenReducers from '../../modules/nitrogen/reducers/NitrogenReducers';
import {sharedOrganisationsReducer} from '../../modules/organisations/redux/SharedOrganisationsReducer';
import RotationsReducers from '../../modules/rotations/reducers/RotationsReducers';
import SoilsReducers from '../../modules/soils/reducers/SoilsReducers';
import SysIrrigationReducers from '../../modules/sysIrrigation/reducers/SysIrrigationReducers';
import VegetationReducers from '../../modules/vegetation/reducers/VegetationReducers';
import WaterBalanceReducers from '../../modules/waterBalance/reducers/WaterBalanceReducers';
import Common from './Common';
import Settings from './Setting';

const reducers = {
  settings: Settings,
  auth: AuthReducers,
  fields: FieldsReducers,
  common: Common,
  crops: CropsReducers,
  soils: SoilsReducers,
  waterBalance: WaterBalanceReducers,
  sysIrrigation: SysIrrigationReducers,
  campaigns: CampaignsReducers,
  rotations: RotationsReducers,
  nitrogen: NitrogenReducers,
  vegetation: VegetationReducers,
  weather: WeatherReducers,
  reportOld: reportReducer,
  report: sharedReportReducers,
  notifications: sharedNotificationsReducer,
  visioCrop: visioCropReducers,
  subscriptions: SubscriptionsReducers,
  contracts: sharedContractReducer,
  commercialPackages: sharedCommercialPackagesReducer,
  organisations: sharedOrganisationsReducer,
  processings: sharedProcessingReducer,
};

export default reducers;
